import { render, staticRenderFns } from "./TopicIapHigh.vue?vue&type=template&id=8ce43736"
import script from "./TopicIapHigh.vue?vue&type=script&lang=js"
export * from "./TopicIapHigh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports